// 所有的模块进行统一处理 导出一个统一的方法 useStore
import React from "react";
import { observer } from "mobx-react-lite";
import { runInAction, set, toJS } from "mobx";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";




// 动态路由
import { LayoutStore } from "@/store/Layout";

//登录
import { LoginStore } from "@/store/Login";
import { ShedsStore } from "./Sheds";
import { DeviceStore } from './Device'
import { PoliceStore } from './Police'
import { VideoStore } from "./Video";
// import {}
class RootStore {
    constructor() {
        this.LayoutStore = new LayoutStore()
        this.LoginStore = new LoginStore()
        this.ShedsStore = new ShedsStore()
        this.DeviceStore = new DeviceStore()
        this.PoliceStore = new PoliceStore()
        this.VideoStore = new VideoStore()
    }

}

//实例化根store注入context
const rootStore = new RootStore();
const context = React.createContext(rootStore);
//导出useStore方
const useStore = () => React.useContext(context);
export {
  useStore,
  observer,
  runInAction,
  set,
  toJS,
  useLocation,
  useSearchParams,
  useNavigate,
};
